<script setup>

import GridCellDetail from "@/components/common/other/GridCellDetail";
import GridCellHeaderAndValue from "@/components/common/other/GridCellHeaderAndValue";
import MoreInfoPopOutPanel from "@/components/common/other/MoreInfoPopOutPanel";
import StockDescriptions from "@/components/warehouse/StockDescriptions";
import DataGrid from "@/components/common/other/DataGrid";
import SearchToolbar from "@/components/shipments/SearchToolbar"

import {inject, computed} from 'vue';

const shipments = inject("shipments");

const renderWarehouse = computed(() => {

    return shipments.value.viewShipment.warehouseItems?.length

})

</script>

<template class="cmp-warehouse-item-details">

  <SearchToolbar width="1570px">
    <div class="cmp-warehouse-item-details_header-items">
      <div class="label">Warehouse Ref:
        <span class="cmp-warehouse-item-details_data">{{ shipments.warehousePicks.selectedShipmentItem.warehouseRef }}
        </span>
      </div>
      <div class="label">Supplier:
        <span class="cmp-warehouse-item-details_data">{{ shipments.warehousePicks.selectedShipmentItem.supplier }}
        </span>
      </div>
      <div class="label">Customer Ref:
        <span class="cmp-warehouse-item-details_data">{{ shipments.warehousePicks.selectedShipmentItem.customerRef }}
        </span>
      </div>
      <div class="label">Items:
        <span class="cmp-warehouse-item-details_data">{{ shipments.warehousePicks.selectedShipmentItem.pieces }}
        </span>
      </div>
      <div class="label">Gross Weight:
        <span class="cmp-warehouse-item-details_data">{{ shipments.warehousePicks.selectedShipmentItem.grossWeight }}
        </span>
      </div>
      <div class="label">Cube:
        <span class="cmp-warehouse-item-details_data">{{ shipments.warehousePicks.selectedShipmentItem.cube }}
        </span>
      </div>
    </div>
  </SearchToolbar>

  <DataGrid
      :key="renderWarehouse"
      height="460"
      :selectable="false"
      :row-selection="false"
      :allow-grid-menu="false"
      :allowPagination="false"
      :columns="shipments.warehousePicks.gridColumns"
      :dataSource="shipments.viewShipment.warehouseItems">
    <template v-slot:skuProperties="row">
      <GridCellDetail>
        <template #details>
          <MoreInfoPopOutPanel
              v-model="row.grid">
            <template #header>Stock Item Properties</template>
            <template #header-extra>SKU Number: {{ row.grid.skuNumber }}</template>
            <template #content>
              <StockDescriptions v-model="row.grid.skuProperties"></StockDescriptions>
            </template>
          </MoreInfoPopOutPanel>
        </template>
        <template #cell-data>
          <GridCellHeaderAndValue
              v-model="row.grid.skuProperties">
          </GridCellHeaderAndValue>
        </template>
      </GridCellDetail>
    </template>
  </DataGrid>
</template>

<style lang="scss" scoped>

.cmp-warehouse-item-details {

  &_header-items {
    display: grid;
    padding-left: 10px;
    grid-template-columns: 320px 415px 310px 150px 230px 100px;
    background-color: #fdfdfd;
    height: 26px;
    width: 100%;
    align-items: center;
    font-size: 13px;
    border: 1px solid #e5e5e5;
  }

  &_data {
    margin-left: 5px;
    font-size: 13px;
    font-weight: normal;
    color: var(--aqua-blue-definition);
  }

}

</style>
